<script>
import { mapState, mapActions } from "vuex";
import Lines from "@/components/chart/Line";
import Bar from "@/components/chart/Bar";

export default {
   data() {
      return {
         chartLoading: false,
         chartdata: null,
         chartLingkungan: null,
      };
   },
   components: { Lines, Bar },
   async mounted() {
      this.chartLoading = false;
      await this.getData().then((res) => {
         this.chartLoading = true;
         // this.chartdata.labels = this.chart.baptis.labels;
         // this.chartdata.datasets[0].data = this.chart.baptis.series;

         this.chartdata = {
            labels: res.data.baptis_chart.labels,
            datasets: [
               {
                  backgroundColor: "rgba(145, 46, 252, 0.3)",
                  borderColor: "rgba(145, 46, 252, 0.8)",
                  strokeColor: "#7366ff",
                  pointBackgroundColor: "#7366ff",
                  pointHoverBackgroundColor: "#fff",
                  pointHoverBorderColor: "#fff",
                  pointHighlightStroke: "#000",
                  data: res.data.baptis_chart.series,
                  label: "Baptis",
               },
            ],
         };

         this.chartLingkungan = {
            labels: res.data.lingkungan_chart.labels,
            datasets: [
               {
                  borderWidth: 1,
                  borderRadius: 15,
                  borderSkipped: false,
                  barThickness: 20,
                  backgroundColor: "rgba(145, 46, 252, 0.4)",
                  borderColor: "rgba(145, 46, 252, 0.6)",
                  hoverBackgroundColor: "rgba(145, 46, 252, 0.6)",
                  data: res.data.lingkungan_chart.series,
                  label: "Umat",
               },
               {
                  borderWidth: 1,
                  borderRadius: 15,
                  borderSkipped: false,
                  barThickness: 20,
                  backgroundColor: "rgba(31, 108, 175, 1)",
                  borderColor: "rgba(18, 94, 161, 1)",
                  hoverBackgroundColor: "rgba(8, 132, 241, 1)",
                  data: res.data.lingkungan_chart.series_kk,
                  label: "Keluarga Katolik",
               },
            ],
         };
      });
   },
   created() { },
   computed: {
      ...mapState({
         status: (state) => state.landing.status,
         chart: (state) => state.landing.chart,
      }),
      isLoading() {
         return this.$store.state.isLoading;
      },
   },
   methods: {
      ...mapActions({
         getData: "landing/getAll",
      }),
      onOpenMaps() {
         window.open("https://peta.parkatkrsintang.id/", '_blank');
      },
      logIn() {
         this.$router.push("/login");
      },
   },
};
</script>

<template>
   <div>
      <div class="page-wrapper horizontal-wrapper">
         <div class="page-header">
            <div class="header-wrapper row m-0">

               <div class="header-logo-wrapper">
                  <div class="logo-wrapper">
                     <router-link to="/dashboard">
                        <img class="img-fluid" src="../assets/images/logo/logo.png" alt />
                     </router-link>
                  </div>
               </div>
               <div class="left-header col horizontal-wrapper pl-0">

               </div>
               <div class="nav-right col-8 pull-right right-header p-0">

                  <ul class="nav-menus">
                     <li>
                        <button class="nav-menus btn btn-primary btn-sm" @click="logIn">
                           Login
                        </button>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
         <div class="page-body-wrapper horizontal-menu">
            <div class="page-body landing-page">
               <transition name="fadeIn" enter-active-class="animated fadeIn">
                  <div>
                     <!-- Container-fluid starts-->
                     <div class="container-fluid " style="padding-top:120px">
                        <div class="row">
                           <div class="col-lg-12">
                              <div class="row">
                                 <div class="col-sm-12 col-md-6">
                                    <px-card class="bg-dark static-top-widget-card card-gradient-0">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="user" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Umat</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total.umat | formatNumber }}
                                                </h4>
                                                <feather type="user" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                                 <div class="col-sm-12 col-md-6">
                                    <px-card class="bg-dark static-top-widget-card card-gradient-0">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="users" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Keluarga Katolik</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total.kk | formatNumber }}
                                                </h4>
                                                <feather type="users" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                                 <div class="col-sm-12 col-md-3">
                                    <px-card class="bg-dark static-top-widget-card card-gradient">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="user-plus" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Baptis ({{ $moment().year() }})</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total_year.baptis | formatNumber }}
                                                </h4>
                                                <feather type="user-plus" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                                 <div class="col-sm-12 col-md-3">
                                    <px-card class="bg-dark static-top-widget-card card-gradient">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="moon" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Komuni I ({{ $moment().year() }})</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total_year.komuni | formatNumber }}
                                                </h4>
                                                <feather type="moon" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                                 <div class="col-sm-12 col-md-3">
                                    <px-card class="bg-dark static-top-widget-card card-gradient">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="user-check" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Krisma ({{ $moment().year() }})</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total_year.krisma | formatNumber }}
                                                </h4>
                                                <feather type="user-check" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                                 <div class="col-sm-12 col-md-3">
                                    <px-card class="bg-dark static-top-widget-card card-gradient">
                                       <div slot="with-padding">
                                          <div class="media static-top-widget">
                                             <div class="align-self-center text-center">
                                                <feather type="link" class="middle"></feather>
                                             </div>
                                             <div class="media-body">
                                                <span class="m-0">Total Perkawinan ({{ $moment().year() }})</span>
                                                <h4 class="mb-0 counter">
                                                   {{ status.total_year.perkawinan | formatNumber }}
                                                </h4>
                                                <feather type="link" class="icon-bg"></feather>
                                             </div>
                                          </div>
                                       </div>
                                    </px-card>
                                 </div>
                              </div>
                           </div>

                           <div class="col-lg-12">
                              <px-card class="card-soft">
                                 <div slot="headerAction"></div>
                                 <div slot="with-padding">
                                    <h6 class="text-muted">Total Baptis (10 Tahun)</h6>
                                    <hr />
                                    <Lines v-if="chartLoading" :chartdata="chartdata" class="chart-height-baptis" />
                                 </div>
                              </px-card>
                           </div>

                           <div class="col-sm-12 col-md-12" @click="onOpenMaps()">
                              <px-card class="bg-dark static-top-widget-card bg-maps">
                                 <div slot="with-padding">
                                    <div class="media static-top-widget">
                                       <div class="align-self-center text-center">
                                          <feather type="map-pin" class="middle"></feather>
                                       </div>
                                       <div class="media-body">
                                          <span class="m-0">Paroki Katedral Kristus Raja Sintang</span>
                                          <h4 class="mb-0 counter">
                                             Peta Wilayah Lingkungan
                                          </h4>
                                          <feather type="map-pin" class="icon-bg"></feather>
                                       </div>
                                    </div>
                                 </div>
                              </px-card>
                           </div>

                           <div class="col-lg-12">
                              <px-card class="card-soft">
                                 <div slot="headerAction"></div>
                                 <div slot="with-padding">
                                    <h6 class="text-muted">Total Umat Per Lingkungan/Stasi</h6>
                                    <hr />
                                    <Bar v-if="chartLoading" :chartdata="chartLingkungan" class="chart-height" />
                                 </div>
                              </px-card>
                           </div>
                        </div>

                        <div class="row">

                        </div>
                     </div>
                     <!-- Container-fluid Ends-->
                  </div>
               </transition>
            </div>
         </div>
      </div>
   </div>
</template>

<style scoped>
.page-wrapper.horizontal-wrapper:before {
   display: none !important;
}

.page-wrapper.horizontal-wrapper .horizontal-menu .page-body {
   margin-top: 0px !important;
}

.page-wrapper .page-header .header-wrapper .nav-right>ul>li {
   padding: 0px 10px !important;
}

@media only screen and (max-width: 575.98px) {
   .page-wrapper .nav-right .nav-menus {
      margin-right: 5px !important;
   }
}

@media only screen and (max-width: 767.98px) {
   .page-wrapper .nav-right .nav-menus {
      margin-right: 5px !important;
   }
}

.chart-height-baptis {
   max-height: 200px;
}

.chart-height {
   max-height: 340px;
}

.bg-maps {
   background-image: url("/img/peta.png");
   background-size: cover;
   background-position: center;
   cursor: pointer;
}

::v-deep .card-soft .card {
   background-color: #ffffffc2 !important
}

.card-gradient-0 {
   /* background-image: linear-gradient(-225deg, #3D4E81 0%, #5753C9 48%, #6E7FF3 100%); */
   background: linear-gradient(90deg, #4b6cb7 0%, #182848 100%);

}

.card-gradient {
   background-image: linear-gradient(-225deg, #FF3CAC 0%, #562B7C 52%, #2B86C5 100%);
}
</style>